import React, { useState } from 'react';
import styled from 'styled-components';
import { breakpoint, Heading, Tooltip } from '@grays-npm/component-library';

export type CarouselDataItem = {
  label?: string | null;
  name: string;
  toolTip?: ToolTipData;
  formattedValue: string;
  actualValue: number | string;
};

export type ToolTipData = {
  title: string;
  text: string;
};

type CarouselCardProps = CarouselDataItem;

const StyledCarouselCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.neutrals.solidGrays[7]};
  display: inline-block;
  padding: ${({ theme }) =>
    `${theme.spacings[4].rem} ${theme.spacings[1].rem}`};
  text-align: center;
  width: 100%;

  &:first-of-type,
  &:last-of-type {
    border-radius: 4px;
  }

  ${breakpoint('lg')`
    padding: ${({ theme }) =>
      `${theme.spacings[5].rem} ${theme.spacings[1].rem}`};
  `}
`;

const Label = styled.label`
  ${({ theme }) => theme.typography.uiText.xs}
  color: ${({ theme }) => theme.colors.neutrals.transparentGrays[2]};
  padding: 0 3px 0 0;

  ${breakpoint('lg')`
    ${({ theme }) => theme.typography.uiText.sm}
  `}
`;

const Value = styled(Heading)`
  margin: 3px 0 0;
  overflow-wrap: break-word;

  ${breakpoint('lg')`
    ${({ theme }) => theme.typography.headings[3]['xl']}
  `}
`;

export const CarouselCard: React.FC<CarouselCardProps> = ({
  label,
  name,
  toolTip,
  formattedValue,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  return (
    <StyledCarouselCard>
      <Label>{label || name}</Label>
      {toolTip?.title && (
        <Tooltip
          {...toolTip}
          callToActionLabel="Ok, got it!"
          controlledVisible={tooltipVisible}
          setControlledVisible={setTooltipVisible}
          onCallToAction={() => setTooltipVisible(false)}
          portalRoot={document.getElementById('portal-root') || undefined}
        />
      )}
      <Value size={4}>{formattedValue}</Value>
    </StyledCarouselCard>
  );
};
